// Copyright 2019 The Oppia Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Requires for all the interactions.
 */
require('interactions/CodeRepl/CodeRepl.ts');
require('interactions/Continue/Continue.ts');
require('interactions/DragAndDropSortInput/DragAndDropSortInput.ts');
require('interactions/EndExploration/EndExploration.ts');
require('interactions/FractionInput/FractionInput.ts');
require('interactions/GraphInput/GraphInput.ts');
require('interactions/ImageClickInput/ImageClickInput.ts');
require('interactions/InteractiveMap/InteractiveMap.ts');
require('interactions/ItemSelectionInput/ItemSelectionInput.ts');
require('interactions/LogicProof/LogicProof.ts');
require('interactions/MathExpressionInput/MathExpressionInput.ts');
require('interactions/MultipleChoiceInput/MultipleChoiceInput.ts');
require('interactions/MusicNotesInput/MusicNotesInput.ts');
require('interactions/NumberWithUnits/NumberWithUnits.ts');
require('interactions/NumericInput/NumericInput.ts');
require('interactions/PencilCodeEditor/PencilCodeEditor.ts');
require('interactions/SetInput/SetInput.ts');
require('interactions/TextInput/TextInput.ts');
